import { render, staticRenderFns } from "./r-trader-order-dropdown.vue?vue&type=template&id=32acc60e"
import script from "./r-trader-order-dropdown.vue?vue&type=script&lang=js"
export * from "./r-trader-order-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32acc60e')) {
      api.createRecord('32acc60e', component.options)
    } else {
      api.reload('32acc60e', component.options)
    }
    module.hot.accept("./r-trader-order-dropdown.vue?vue&type=template&id=32acc60e", function () {
      api.rerender('32acc60e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-trader-order-dropdown.vue"
export default component.exports